// extracted by mini-css-extract-plugin
export default {"ldsSpinner":"LoadingSpinner_ldsSpinner__lhw6Z"};